/**
 * Formats duration in minutes to MM:SS format
 */
export function formatDuration(minutes: number | undefined): string {
  if (!minutes) return '0:00';
  const mins = Math.floor(minutes);
  const secs = Math.floor((minutes - mins) * 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

